<template>
    <DModal
        :title="__('customers.contracts.send_auth_code.send_auth_code_confirmation')"
        is-confirm
        is-big
        :show="showModal || modalHasErrors"
        :is-awaiting-validation="true"
        @confirm="submitAuthCodeConfirmation"
        @close="$emit('close-modal')"
    >
        <div style="padding: 20px;">
            <DAlert
                color="warning"
            >
                {{ __('customers.contracts.send_auth_code.send_auth_code_warning') }}
            </DAlert>
            <DFormRow
                :label="__('customers.contracts.notes.internal')"
                :error="errors.activity_log_comment"
            >
                <DFormTextarea
                    id="activity_log_comment"
                    :model-value="authCodeConfirmationForm.activity_log_comment"
                    rows="5"
                    @update:model-value="authCodeConfirmationForm.activity_log_comment = $event"
                />
            </DFormRow>
        </div>
    </DModal>
</template>

<script>
export default {
    name: 'SendAuthCodeModal',
    props: {
        contract: {
            type: Object,
            default: () => { return {} }
        },
        showModal: {
            type: Boolean,
            default: false
        },
        errorsData: {
            type: Object,
            default: () => { return {} }
        },
        returnUrl: {
            type: String,
            default: () => 'contract-show'
        }
    },
    emits: ['close-modal'],
    data () {
        return {
            authCodeConfirmationForm: this.$inertia.form({
                activity_log_comment: ''
            }),
            errors: { ...this.errorsData },
            modalHasErrors: false
        }
    },
    watch: {
        errorsData: {
            handler (newErrors) {
                this.errors = { ...newErrors }
                this.modalHasErrors = Object.keys(newErrors).length > 0
            },
            deep: true
        }
    },
    methods: {
        submitAuthCodeConfirmation () {
            this.errors.activity_log_comment = null
            this.modalHasErrors = false

            if (!this.authCodeConfirmationForm.activity_log_comment || this.authCodeConfirmationForm.activity_log_comment.trim() === '') {
                this.errors.activity_log_comment = 'Internal notes are required.'
                this.modalHasErrors = true

                return
            }

            this.authCodeConfirmationForm.post(this.$route('customers.customers.contracts.send-auth-code', {
                customer: this.contract.customer_id,
                contract: this.contract.id,
                redirectTo: this.returnUrl
            }), {
                onError: (backendErrors) => {
                    this.errors = backendErrors
                    this.modalHasErrors = true
                }
            })
        }
    }
}
</script>
